import { useAuth } from '@neotech-solutions-org/neofusion-fe-shared';
import { useUserData } from '../queries';
import { EmailVerificationFlowType, useMarketplaceConfig } from '../queries/marketplace';

export const useEmailVerification = (emailVerificationFlowToCheck: EmailVerificationFlowType) => {
  const { isAuthenticated } = useAuth();
  const { data: marketplaceConfig, isLoading: isMarketplaceConfigLoading } = useMarketplaceConfig();
  const { data: userData, isLoading: isUserDataLoading } = useUserData();

  const emailVerified = userData?.emailVerified;
  const emailVerificationFlow = marketplaceConfig?.marketplaceConfig?.registrationFlow?.emailVerification;

  if (isMarketplaceConfigLoading || isUserDataLoading) {
    return false;
  }
  if (!isAuthenticated) {
    return false;
  }
  if (emailVerificationFlow !== emailVerificationFlowToCheck) {
    return false;
  }
  if (emailVerificationFlow === 'none') {
    return false;
  }

  return !emailVerified;
};
